import React from "react";
import Portfolio from "../sections/Portfolio.jsx";
import Clients from "../sections/Clients.jsx";
export default function PagePortfolio() {
  return (
    <>
      <Portfolio />
      <Clients />
    </>
  );
}
